<template>
  <viewer :options="options">
    <el-row :gutter="gutter">
      <el-col
        v-for="(item, index) in newImage"
        :key="rowKey ? item[rowKey] : index"
        :span="setSpan ? setSpan(item, index) : span"
      >
        <slot :row="item" :index="index" :disabled="setDisabled(item)"/>
      </el-col>
    </el-row>
  </viewer>
</template>

<script>
export default {
  name: 'BaseImageGrid',

  props: {
    images: {
      type: Array,
      default: () => []
    },
    gutter: {
      type: Number,
      default: 20
    },
    span: {
      type: Number,
      default: 6
    },
    rowKey: String,
    srcKey: String,
    exclude: {
      type: Array,
      default: () => ['no_photo']
    },
    setSpan: Function,
    url: [String, Function]
  },
  data () {
    return {
      newImage: []
    }
  },

  computed: {
    options () {
      return {
        filter: img => !img.dataset.disable,
        url: this.url,
        title: [4, (image, imageData) => `${image.alt} (${imageData.naturalWidth} × ${imageData.naturalHeight})`]
      }
    }
  },

  watch: {
    images (val) {
      this.newImage = []
      this.$nextTick(() => {
        this.newImage = val
      })
    }
  },
  methods: {
    setDisabled (row) {
      if (this.srcKey && row) {
        const src = row[this.srcKey]
        return !src || this.exclude.some(k => src.indexOf(k) > -1)
      }
      return false
    }
  }
}
</script>

<style lang="scss" scoped></style>
